import { Operation } from '@occc-app/offerHelpers/types';
import { OfferFragment } from '@occc/graphql';

import { OfferType } from '../../../../offerValidationService/types';
import { constraintHelper } from '../../../../offerHelpers/utils/constraintHelper';
import { makeCreateRequiresVoucherConstraintOperation } from '../../../../offerHelpers/operations/constraints';

export const getConstraintOperations = (
  offer: OfferFragment | undefined,
  offerType: OfferType | null,
): Operation[] => {
  if (offerType !== OfferType.VoucheredGame || !offer) {
    return [];
  }
  // Do not create constraint if already exists
  if (offer?.constraints.find(constraintHelper.isRequiresVoucher)) {
    return [];
  }

  return [makeCreateRequiresVoucherConstraintOperation(offer.id)];
};
